import React from 'react'
import { useContext } from 'react'

import {TodoContext} from '../API'
const Display=()=>{
    const [todo,setTodo]=useContext(TodoContext)


    const del=(itemId)=>{
        
        let items=todo.filter(data=>data.id !== itemId)
        setTodo(items)
    }

    const toggleComplete=(index)=>{
            let items=[...todo]
            items[index].isComplete=!items[index].isComplete
            setTodo(items)
    }

    

    if(todo){
        let style=""
    return(
       <table className="table">
           <tbody>
           {todo.map((item,id)=>{
               {item.isComplete?style="strike":style=""}
               return(
               <tr key={id}>
                   <td><span className={style}>{item.title}</span></td>
                   <td className="d-flex justify-content-end"> 
                   <span className="badge badge-success mx-2" onClick={()=>toggleComplete(id)}> <i className="fa fa-check delete "></i> </span>

                   <span className="badge badge-danger" onClick={()=>del(item.id)}> <i className="fa fa-trash delete"></i> </span>
                   </td>
               </tr>
               )
           })}
           </tbody>
       </table>
        
    )
        }

    else{
        return(
        <h3>No todos</h3>
        )
    }
}

export default Display